interface ChartYAxisState {
    name: string;
    height: any;
    top: any;
}

export class ChartYAxisStateModel {
    public static Version = 4;
    public currentVersion = ChartYAxisStateModel.Version;
    public states: Array<ChartYAxisState> = [];
    public chartHeight = 0;
    public chartWidth = 0;
}